import {useQuery} from "@tanstack/react-query";
import {readAccountApi} from "../../../../api/account/AccountApi";
import {BasicSearchType} from "../../../../types/common/basic";


export const useReadUserAccount = (param: BasicSearchType) => {
    const {data} = useQuery({
        queryKey: ["readUserAccountInModal", param],
        queryFn: async () => await readAccountApi(param),
        select: (res) => res?.data.result ?? {
            totalCount: 0,
            userList: []
        },
    });

    return {data};
};
